import React, { useState, useEffect } from "react";
import { Typography, TextField, Button } from "@mui/material";
import FloatSlider from '../sliders/FloatSlider';

export type WearFilterProps = {
  floatMin: number;
  floatMax: number;
  onChange: (min: number, max: number) => void;
};

const FloatFilter: React.FC<WearFilterProps> = ({
                                                  floatMin,
                                                  floatMax,
                                                  onChange,
                                                }) => {
  const [open, setOpen] = useState(false);

  // Lokaler State → Slider + Textfelder teilen ihn
  const [localMin, setLocalMin] = useState(floatMin);
  const [localMax, setLocalMax] = useState(floatMax);

  // Wenn Parent updated (Filter reset), übernehmen
  useEffect(() => {
    setLocalMin(floatMin);
    setLocalMax(floatMax);
  }, [floatMin, floatMax]);

  // Trigger API while typing with debounce
  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(localMin, localMax);
    }, 300);

    return () => clearTimeout(timer);
  }, [localMin, localMax]);

  const textFieldSx = {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
      margin: 0,
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& .MuiInputBase-input': {
      fontSize: '0.80rem',
      fontWeight: 600,
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.80rem',
      fontWeight: 600,
    },
  };

  return (
      <div
          className="rounded-[4px]"
          style={{
            padding: "1px",
            background:
                "linear-gradient(90deg,#14532d,#22c55e,#eab308,#f87171,#b91c1c)",
          }}
      >
        <div className="rounded-[4px] overflow-hidden">

          <button
              onClick={() => setOpen(!open)}
              className={`w-full flex justify-between px-3 py-2 text-sm ${
                  open ? "bg-transparent" : "bg-neutral-900"
              }`}
          >
            <span className="!text-[0.80rem] !font-semibold text-gray-300">Float</span>
            <span className="!text-[0.80rem] !font-semibold">{open ? "▲" : "▼"}</span>
          </button>

          <div
              className={`overflow-hidden transition-all duration-220 ${
                  open ? "max-h-[9999px]" : "max-h-0"
              }`}
          >
            <div className="px-3 pb-4 pt-2 space-y-3 bg-neutral-900">

              <Typography className="text-gray-300 !text-[0.80rem] !font-semibold">
                0.00 – 1.00
              </Typography>

              {/* SLIDER (lokaler State) */}
              <FloatSlider
                  value={[localMin, localMax]}
                  onChange={(min, max) => {
                    setLocalMin(Math.max(0, min));
                    setLocalMax(Math.max(0, max));
                  }}
                  onCommit={() => {}}
              />

              {/* TEXTFELDER (direkt lokal) */}
              <div className="flex gap-2">
                <TextField
                    size="small"
                    label="Min"
                    type="number"
                    value={localMin}
                    onChange={(e) => setLocalMin(Math.max(0, Number(e.target.value)))}
                    className="flex-1"
                    sx={textFieldSx}
                />

                <TextField
                    size="small"
                    label="Max"
                    type="number"
                    value={localMax}
                    onChange={(e) => setLocalMax(Math.max(0, Number(e.target.value)))}
                    className="flex-1"
                    sx={textFieldSx}
                />
              </div>

              {/* QUICK BUTTONS */}
              <div className="flex flex-wrap gap-2">
                <Button className="!text-[0.80rem] !font-semibold" size="small" variant="outlined" onClick={() => { setLocalMin(0); setLocalMax(0.07); }}>FN</Button>
                <Button className="!text-[0.80rem] !font-semibold" size="small" variant="outlined" onClick={() => { setLocalMin(0.07); setLocalMax(0.15); }}>MW</Button>
                <Button className="!text-[0.80rem] !font-semibold" size="small" variant="outlined" onClick={() => { setLocalMin(0.15); setLocalMax(0.38); }}>FT</Button>
                <Button className="!text-[0.80rem] !font-semibold" size="small" variant="outlined" onClick={() => { setLocalMin(0.38); setLocalMax(0.45); }}>WW</Button>
                <Button className="!text-[0.80rem] !font-semibold" size="small" variant="outlined" onClick={() => { setLocalMin(0.45); setLocalMax(1); }}>BS</Button>
              </div>

            </div>
          </div>

        </div>
      </div>
  );
};

export default FloatFilter;